module.exports = __webpack_public_path__ + "media/images/character-82cf692616a2bd323c7f6cae29328948.png";